import React from 'react';
import { cn } from '@/lib/utils';

export function PeriodFilter({ options, value, onChange }) {
  return (
    <div className="flex w-full max-w-full gap-2 overflow-x-auto rounded-full border border-neutral-lighter bg-white p-1.5 [&::-webkit-scrollbar]:hidden md:w-fit">
      {options.map(option => (
        <button
          key={option.value}
          type="button"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            'shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-bold transition-colors',
            value === option.value ? 'bg-[var(--color-mission)] text-white' : 'text-neutral-dark hover:bg-neutral-100'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
